import { ChangeDetectorRef, Component, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DisplayMode } from 'cbc-shared-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  CodeConversionMstDto,
  Sgke382aRequest,
  Sgke382aResponse, Sgke382aResponseSearchResultList,
  Sgke383aRequest,
  Sgke383aRequestUpdateCondition,
  Sgke384aRequest,
  Sgke384aRequestUpdateCondition,
  Sgke385aRequest,
  Sgke385aRequestUpdateCondition,
  Sgke903aRequest,
  Sgke903aRequestReqBusinessArea,
  Sgke903aResponse,
  Sgke903aResponseCompanyAreaInfo,
  Sgke903aResponseInitialhyojiInfo,
  Sgke903aResponseResponseBusinessArea
} from 'sg-api';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { UsedSgke903aService } from '../../../../../sg-ke-shared/services/used-sgke903a.service';
import { Sgke380dSearchResultComponent } from '../../components/sgke380d-search-result/sgke380d-search-result.component';
import { UsedSgke382aService } from '../../services/used-sgke382a.service';
import { UsedSgke383aService } from '../../services/used-sgke383a.service';
import { UsedSgke384aService } from '../../services/used-sgke384a.service';
import { UsedSgke385aService } from '../../services/used-sgke385a.service';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';
import { CodeConversionMstService } from '../../../../../../sg-base/sg-base-shared/services/codeConversionMst.service';

@Component({
  selector: 'app-sgke380d',
  templateUrl: './sgke380d.component.html',
  styleUrl: './sgke380d.component.scss'
})
export class Sgke380dComponent implements OnInit, OnDestroy {

  @ViewChild(Sgke380dSearchResultComponent) sgke380dSearchResultComponent!: Sgke380dSearchResultComponent;

  /** 処理結果コード（異常終了） */
  static ABNORMAL_END: string = "9";

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /** モード区分_登録 */
  public MODE_CREATE = DisplayMode.create;
  /** モード区分_更新 */
  public MODE_UPDATE = DisplayMode.update;

  /** メッセージエリア */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();
  /** 画面モード（サービサー委託対象検索画面/サービサー返却検索画面） */
  task: string = this.MODE_CREATE;
  /** FormGroup */
  approvalReqForm: UntypedFormGroup = this.fb.group({});
  /** SGKE382A_サービサー委託対象検索APIレスポンス */
  response: Sgke382aResponse;
  /** SGKE382A_サービサー委託対象検索API検索結果リスト */
  searchResultList: Array<Sgke382aResponseSearchResultList>;
  /** サービサー委託対象登録APIレスポンス */
  responseSgke903a: Sgke903aResponse;
  /** SGKE903A_会社地区情報取得APIレスポンス業務エリア */
  responseBusinessArea: Sgke903aResponseResponseBusinessArea;
  /** SGKE903A_会社地区情報取得API会社地区情報 */
  cmpnyAreaList: Array<Sgke903aResponseCompanyAreaInfo>;
  /** SGKE903A_会社地区情報取得API初期表示情報 */
  cmpnyAreaInit: Sgke903aResponseInitialhyojiInfo;
  /** サービサー委託対象検索APIのForm */
  searchReqForm: UntypedFormGroup;

  /** 検索APIリクエスト */
  requestSgke382a: Sgke382aRequest;
  /** コード変換マスタマップ */
  codeConversionMstMap: Map<string, Array<CodeConversionMstDto>> = null;

  /**
   * 検索済フラグ
   * @readonly
   * @type {boolean}
   * @memberof Sgke380dComponent
   */
  get searched(): boolean {
    return this.searchResultList?.length > 0;
  }

  /**
   * コンストラクタ
   * @param {UsedSgke382aService} searchService
   * @param {UsedSgke383aService} updateTargetService
   * @param {UsedSgke384aService} updateRelocationResearchService
   * @param {UsedSgke385aService} updateRecnsgnService
   * @param {UsedSgke903aService} companyAreaInfoService
   * @param {UntypedFormBuilder} fb
   * @param {ActivatedRoute} route
   * @param {Router} router
   * @param {ChangeDetectorRef} cd
   * @param {ResponseMsgUtils} responseMsgUtils
   * @memberof Sgke380dComponent
   */
  constructor(
    public searchService: UsedSgke382aService,
    public updateTargetService: UsedSgke383aService,
    public updateRelocationResearchService: UsedSgke384aService,
    public updateRecnsgnService: UsedSgke385aService,
    public companyAreaInfoService: UsedSgke903aService,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private cd: ChangeDetectorRef,
    private responseMsgUtils: ResponseMsgUtils,
    private codeConversionMstService: CodeConversionMstService,
  ) {
  }

  /**
   * 初期処理
   * @memberof Sgke380dComponent
   */
  ngOnInit() {

    this.route.paramMap.subscribe(params => {

      // navigateのパラメータ値を設定 サービサー委託対象検索画面：mode="create" サービサー返却検索画面：mode="update"
      this.task = params.get('mode');

      // サービサー委託対象検索APIのFormを初期化
      this.searchReqForm = this.fb.group({
        requestCommon: new UntypedFormGroup({}),
      });

      // クリア処理
      this.clear();
      this.responseSgke903a = null;

      this.companyAreaInfo();

      // コード変換マスタ取得
      let dispItemIdList = [
        'S300010',
        'S300160',
        'S300161',
        'S300030',
        'S300110',
        'S300040',
      ];
      // コード変換マスタ共通コンポーネント呼び出し
      this.codeConversionMstService.getCodeConversionMst(dispItemIdList)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(data => {
          // ローカルに保存
          this.codeConversionMstMap = data;
        });

    });

  }

  /**
   * 購読解除
   * @memberof Sgke380dComponent
   */
  ngOnDestroy(): void {
    //購読を停止する処理
    this.onDestroy$.next();
  }

  /**
   * SGKE382A_サービサー委託対象検索API呼出し
   * @param {boolean} isFromSearchBtn
   * @memberof Sgke380dComponent
   */
  search(isFromSearchBtn: boolean = true) {

    // searchResult初期化
    this.searchResultList = null;

    if (isFromSearchBtn) {
      // メッセージクリア
      this.errorMessageModelArray = new Array<SgAriaMessage>();
      this.cd.detectChanges();
      this.requestSgke382a = this.searchReqForm.getRawValue() as Sgke382aRequest;
    }


    this.requestSgke382a.cndt = {
      ...this.requestSgke382a.cndt,
      // 表示条件フラグ
      hyojiCndtFlg: this.task == this.MODE_UPDATE ? false:true,
    };
    this.searchService.doSgke382a(this.requestSgke382a)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        if (response?.responseCommon?.resultCode === "0") {
          this.response = response;
          this.searchResultList = response.searchResultList;
        }
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      }, error => {
      });
  }

  /**
   * SGKE383A_サービサー委託対象委託登録API呼出し
   * @param {Sgke382aResponseSearchResultList[]} requestInfo
   * @memberof Sgke380dComponent
   */
  updateTarget(requestInfo: Sgke382aResponseSearchResultList[]) {

    // エラーメッセージクリア
    this.clearErrorMsg();

    let request: Sgke383aRequest = {
      requestCommon: undefined,
      updateCndtList: []
    };

    request.updateCndtList = requestInfo.map(x => {
      let result: Sgke383aRequestUpdateCondition = {
        // 委託番号
        consignNo: x.consignNo,
        // 委託履歴番号
        consignRrkNo: x.consignRrkNo,
        // サービサー委託対象コード
        servicerConsignmenttargetCode: x.servicerconsignmenttargetCodevalue,
        // 委託先コード
        servicerConsignmenttoCode: x.consignmenttoCodevalue,
        // 更新通番号
        servicerCommissionmanagementUpdatesequencenumber: x.servicerCommissionmanagementUpdatesequencenumber
      };

      return result;
    })

    this.updateTargetService.doSgke383a(request)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        this.handleRegistResponse,
        this.handleError,
      );
  }

  /**
   * SGKE384A_サービサー委託対象移転先調査要否登録API呼出し
   * @param {Sgke382aResponseSearchResultList[]} requestInfo
   * @memberof Sgke380dComponent
   */
  updateRelocationResearch(requestInfo: Sgke382aResponseSearchResultList[]) {

    // エラーメッセージクリア
    this.clearErrorMsg();

    let request: Sgke384aRequest = {
      requestCommon: undefined,
      updateCndtList: []
    };

    request.updateCndtList = requestInfo.map(x => {
      let result: Sgke384aRequestUpdateCondition = {
        // 委託番号
        consignNo: x.consignNo,
        // 委託履歴番号
        consignRrkNo: x.consignRrkNo,
        // 移転先調査要否コード
        transferdestinationTyosaYhicode: x.transferdestinationTyosayohiCodevalue,
        // 更新通番号
        servicerCommissionmanagementUpdatesequencenumber: x.servicerCommissionmanagementUpdatesequencenumber
      };

      return result;
    })

    this.updateRelocationResearchService.doSgke384a(request)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        this.handleRegistResponse,
        this.handleError,
      );
  }

  /**
   * SGKE385A_サービサー委託対象委託再登録API呼出し
   * @param {Sgke382aResponseSearchResultList[]} requestInfo
   * @memberof Sgke380dComponent
   */
  updateRecnsgn(requestInfo: Sgke382aResponseSearchResultList[]) {

    // エラーメッセージクリア
    this.clearErrorMsg();

    let request: Sgke385aRequest = {
      requestCommon: undefined,
      updateCndtList: []
    };

    request.updateCndtList = requestInfo.map(x => {
      let result: Sgke385aRequestUpdateCondition = {
        // 更新条件フラグ
        updateCndtFlg: x.saishureconsignmentyesnoStateCodevalue == null ? false : true,
        // 委託番号
        consignNo: x.consignNo,
        // 委託履歴番号
        consignRrkNo: x.consignRrkNo,
        // サービサー再委託対象コード
        servicerRecommissiontargetCode: x.servicerRecommissiontargetCodevalue,
        // 再委託対象外理由コード
        recommissionTargetgaiRsncod: x.recommissiontargetTargetgairsnCodevalue,
        // サービサー委託先コード
        servicerConsignmenttoCode: x.consignmenttoCodevalue,
        // 更新通番号
        servicerCommissionmanagementUpdatesequencenumber: x.servicerCommissionmanagementUpdatesequencenumber
      };

      return result;
    })

    this.updateRecnsgnService.doSgke385a(request)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        this.handleRegistResponse,
        this.handleError,
      );
  }

  /**
   * SGKE903A_会社地区情報取得API呼出し
   * @memberof Sgke380dComponent
   */
  companyAreaInfo() {
    let reqItem: Sgke903aRequestReqBusinessArea = {
      gamenId: "SGKE380D"
    };
    let requestInfo: Sgke903aRequest = {
      requestCommon: undefined,
      reqBusinessArea: reqItem
    };

    this.companyAreaInfoService.doSgke903a(requestInfo)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        if (response?.responseBusinessArea?.companyAreaInformationlist) {
          this.responseSgke903a = response;
          this.cmpnyAreaList = response.responseBusinessArea.companyAreaInformationlist;
          this.cmpnyAreaInit = response.responseBusinessArea.initialhyojiInfo;
        }

        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      },
        error => {
        });
  }

  /**
   * クリア処理
   * @memberof Sgke380dComponent
   */
  clear() {
    this.clearErrorMsg();
    this.searchResultList = null;
  }

  /**
   * 請求ポータル画面へ遷移
   * @param {Sgke382aResponseSearchResultList} row
   * @memberof Sgke380dComponent
   */
  onClickBillingPortal(row: Sgke382aResponseSearchResultList): void {
    // 受付基盤UIのURL取得
    const url: string = (window as any).__env.ACEPTBASE_UI_BASE_PATH;
    // anyタイプのパラメータ
    let paramToOutside: any = {};

    // お客さま番号
    let customerNo: string = row.visitornumber;
    // 支払契約番号
    let paymentContractNo: string = row.payCtrNo;
    // パラメータ設定
    // お客さま番号
    if (customerNo) {
      paramToOutside.c__customerNo = customerNo;
    }
    // 支払契約番号
    if (paymentContractNo) {
      paramToOutside.c__paymentContractNo = paymentContractNo;
    }
    // 起動元画面
    paramToOutside.c__launchSourceScreen = '7';

    //  anyタイプをクエリ文字列に変換
    let params: string = new URLSearchParams(paramToOutside).toString();
    if (params) {
      params = '?' + params;
    };
    // 別タブで該当URLを開く
    window.open(`${url}${params}`, '_blank');
  }

  /**
   * レスポンス共通処理
   * @private
   * @param {any} response 
   * @memberof Sgke380dComponent
   */
  private handleRegistResponse = (response: any): void => {
    if (response) {
      // メッセージを表示
      this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      this.search(false);
    }
  }

  /**
   * エラーメッセージ表示領域をクリア
   * @private
   * @memberof Sgke380dComponent
   */
  private clearErrorMsg() {
    this.errorMessageModelArray.length = 0;
  }

  /**
   * エラー共通処理
   * @private
   * @param {any} error
   * @memberof Sgke380dComponent
   */
  private handleError = (error: any): void => {
  }

}

